type FetchWithTimeoutOptions = RequestInit & { timeout?: number };

const DEFAULT_WEBHOOK_TIMEOUT = 12 * 1000;
const fetchWithTimeout = async (
  resource: RequestInfo,
  options: FetchWithTimeoutOptions = {},
) => {
  const { timeout = DEFAULT_WEBHOOK_TIMEOUT } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
    credentials: 'same-origin',
  });
  clearTimeout(id);

  return response;
};

export default fetchWithTimeout;
